module.exports = __webpack_public_path__ + "static/img/COVER-4.bf74d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-4.png
// module id = BzAj
// module chunks = 31